import { LanguageInitializerService } from '@/app/core/services/language-initializer.service';
import { LanguageViewModel } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'auth-header',
  imports: [SharedModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
})
export class HeaderComponent implements OnInit {
  @Output() selectedLanguageGuid = new EventEmitter<string>();
  languages: LanguageViewModel[] = [];
  selectedLanguage: LanguageViewModel | undefined;

  constructor(private _languageInitializerService: LanguageInitializerService) {}

  ngOnInit(): void {
    this.languages = this._languageInitializerService.getLanguages();
    this.selectedLanguage = this.languages.find((c) => c.id == this.getCurrentLanguage());
  }

  onLanguageChange(event: any) {
    let language = event.value as LanguageViewModel;
    this._languageInitializerService.setLanguage(language.id);
  }

  getCurrentLanguage(): string {
    return this._languageInitializerService.getCurrentLanguageGuid();
  }
}
